module.exports = __webpack_public_path__ + "static/img/Round-02-2011.b2a9753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-02-2011.jpg
// module id = r5po
// module chunks = 0